import styled, { css } from 'styled-components';

import { Choice, Loader } from 'shared/components';
import { variableFontRegular } from 'styles/theme';

interface IQuestionForm {
  checked: number | string;
  className?: string;
  'data-qa': string;
  error?: string;
  gridStyle?: { [key: string]: string };
  invertChecked?: boolean;
  isGrid?: boolean;
  isLoading?: boolean;
  name: string;
  onChange: (e) => void;
  options: { label: string; value: number | string }[];
  question: string;
  darkTheme?: boolean;
}

export const QuestionForm = ({
  checked,
  className,
  'data-qa': dataQa,
  error,
  gridStyle,
  invertChecked = false,
  isGrid = false,
  isLoading = false,
  name,
  onChange,
  options,
  question,
  darkTheme,
}: IQuestionForm) => {
  return (
    <QuestionForm.Wrapper data-qa={`${dataQa}_question_form`} className={className}>
      <QuestionForm.Question>{question}</QuestionForm.Question>
      {isLoading ? (
        <QuestionForm.Loader>
          <Loader />
        </QuestionForm.Loader>
      ) : (
        <QuestionForm.RadioOptions data-qa={`${dataQa}_options`} $isGrid={isGrid} style={gridStyle}>
          {options.map((option) => (
            <Choice
              checked={String(checked) === String(option.value)}
              key={option.value}
              invertChecked={invertChecked}
              label={option.label}
              onChange={onChange}
              name={name}
              type="radio"
              value={option.value}
              data-qa={`${option.value}_${dataQa}_choice`}
              darkTheme={darkTheme}
            />
          ))}
        </QuestionForm.RadioOptions>
      )}
      {error && <QuestionForm.Error>{error}</QuestionForm.Error>}
    </QuestionForm.Wrapper>
  );
};

QuestionForm.Loader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 105px;
`;

QuestionForm.Wrapper = styled.fieldset`
  border: none;
  padding: 0;
  margin-bottom: 24px;
`;

QuestionForm.Question = styled.legend`
  margin-bottom: 16px;
  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })}
  }
`;

QuestionForm.RadioOptions = styled.div<{ $isGrid: IQuestionForm['isGrid'] }>`
  width: 100%;

  ${({ $isGrid }) =>
    $isGrid
      ? css`
          display: grid;
          grid-gap: 16px;
          grid-template-columns: repeat(7, 1fr);
        `
      : css`
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 16px;
        `}
`;

QuestionForm.Error = styled.div`
  color: ${({ theme }) => theme.colors.red};
  ${variableFontRegular({ size: '9.5px', height: '12px' })};
  margin: 12px 0 0;
`;
